<div id="how-to-reach" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h1 class="title">How to Reach Us</h1>
    <p class="inner-lead mt-3">
      Shah Satnam Ji Girls' College is conveniently located in Sirsa, Haryana. The college is easily accessible by road, rail, and other modes of transportation.
    </p>

    <hr class="divider">

    <div class="row g-4 mt-2">
      <div class="col-md-6">
        <h4 class="section-subtitle">College Address</h4>
        <ul class="list-styled mt-3">
          <li><strong>Name:</strong> Shah Satnam Ji Girls' College</li>
          <li><strong>Address:</strong> Near Shah Satnam Ji Speciality Hospital, Bhadra Road, Sirsa, Haryana 125055</li>
          <li><strong>Phone:</strong> +91 9729458602, 01666-238602</li>
          <li><strong>Email:</strong> ssji1525@gmail.com, ssgians1@gmail.com</li>
        </ul>

        <h4 class="section-subtitle mt-4">By Road</h4>
        <ul class="list-styled mt-3">
          <li>The college is located on Bhadra Road near Shah Satnam Ji Speciality Hospital.</li>
          <li>Easily accessible by bus, auto-rickshaw, and taxi from Sirsa city.</li>
          <li>Ample parking space is available inside the campus.</li>
        </ul>

        <h4 class="section-subtitle mt-4">By Rail</h4>
        <ul class="list-styled mt-3">
          <li>Nearest railway station: Sirsa Railway Station (approx. 10 km).</li>
          <li>Auto-rickshaws and taxis are available from the station and bus stand.</li>
        </ul>

        <h4 class="section-subtitle mt-4">By Air</h4>
        <ul class="list-styled mt-3">
          <li>Nearest airport: Hisar Airport (~80 km).</li>
          <li>Chandigarh International Airport (~230 km).</li>
        </ul>
      </div>

      <div class="col-md-6">
        <h4 class="section-subtitle">Location Map</h4>
        <div class="mt-3 rounded overflow-hidden" style="height: 400px;">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3468.123456789!2d75.0313!3d29.5395!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39116744f470691b%3A0xc3f9a744f470691b!2sShah%20Satnam%20Ji%20Girls%20College!5e0!3m2!1sen!2sin!4v1620000000000!5m2!1sen!2sin"
            width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy"
            referrerpolicy="no-referrer-when-downgrade">
          </iframe>
        </div>
      </div>
    </div>

  </div>
</div>
